import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CuadroDialogoComponent } from 'app/componentes/cuadro-dialogo/cuadro-dialogo.component';
import { MatDialogComponent } from 'app/componentes/mat-dialog/mat-dialog.component';
import { DocumentService } from 'app/services/documentos.service';
import { DataService } from 'app/services/secciones.service';
import { EmpresaService } from 'app/services/vinculacion/empresa/empresa.service';
import { environment } from 'environments/environment.prod';
import moment = require('moment');
import { Observable } from 'rxjs';

@Component({
  selector: 'app-empresa-detalle',
  templateUrl: './empresa-detalle.component.html',
  styleUrls: ['./empresa-detalle.component.scss']
})
export class EmpresaDetalleComponent implements OnInit {

  obtenerId = () => this.activatedRoute.snapshot.params;
  //OBTENEMOS EL ID DE LA SEDE QUE EL USUARIO SELECCIONO 
  idEmpresa: string = this.obtenerId().idEmpresa;

  //VARIABLES
  edit: boolean = false;
  empresas_avisos: any = []
  array: any = [];
  imagenes: any = [];
  IMAGEN_HOST = environment.API_IMAGEN;
  labelPosition:number = 1

  //DECLARACIÓN DE FORMULARIOS REACTIVOS 

  EmpresaForm = new FormGroup({
    fecha: new FormControl(new Date, Validators.required),
    titulo: new FormControl('', Validators.required),
    contenido: new FormControl('', Validators.required),
    orden: new FormControl(0),
    estado: new FormControl('')
  });

  ImagenesForm = new FormGroup({
    idEmpresa: new FormControl(''),
    rutaImagen: new FormControl(null),
    principal: new FormControl(0)

  })

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    public navigation: DataService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private servicioEmpresa: EmpresaService,
    private serviciodocumento: DocumentService
  ) { }

  ngOnInit(): void {
    if (this.idEmpresa) {
      this.obtenerImagenes()
      this.servicioEmpresa.getEmpresa(this.idEmpresa).subscribe(response => {
        this.EmpresaForm.patchValue(response[0])
      });
    }
  }

  obtenerImagenes = () => {
    this.servicioEmpresa.getImagenes(this.idEmpresa).subscribe(response => {
      this.imagenes = response;
    });
  }

  //VERIFICAMOS SI EL USUARIO VA A SALIR DE LA RUTA  CON DATOS EN EL FORMULARIO
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.EmpresaForm.dirty) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          message: ' ¿ Desea salir sin guardar los cambios ? ',
          buttonText: {
            ok: 'Aceptar',
            cancel: 'Cancelar'
          }
        }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }

  guardarDatos = () => {

    let result: any = {};
    let id;
    let datos: any = [];
    let imagen = this.ImagenesForm.get('rutaImagen').value;
    this.EmpresaForm.controls['fecha'].setValue(moment(this.EmpresaForm.get('fecha').value).format('YYYY-MM-DD'));   

    this.servicioEmpresa.getEmpresasAvisos().subscribe(response =>{
      datos = response;
      if(response){
        this.EmpresaForm.controls['orden'].setValue(datos.length + 1)
        this.servicioEmpresa.crearEmpresa(this.EmpresaForm.value).subscribe(response => {
          result = response;
          id = result.reps[0].id;
    
        if(this.ImagenesForm.get('rutaImagen').value){
          imagen._files.forEach(element => {
            this.ImagenesForm.get('rutaImagen').setValue(element.name)
            this.ImagenesForm.get('idEmpresa').setValue(id)
            this.servicioEmpresa.crearImagenes(this.ImagenesForm.value).subscribe(response => {
              this.guardarImagenPHP(imagen);
            })
          });
        }
          this.EmpresaForm.markAsPristine()
          this.EmpresaForm.markAllAsTouched()
          this.openSnackBar("REGISTRO CREADO CORRECTAMENTE!")
          this.router.navigateByUrl('/empresa')
        });
      }
    })


  }

  actualizarDatos = () => {

    let imagen = this.ImagenesForm.get('rutaImagen').value;
    this.EmpresaForm.controls['fecha'].setValue(moment(this.EmpresaForm.get('fecha').value).format('YYYY-MM-DD'));   
    if(this.ImagenesForm.get('rutaImagen').value){
      imagen._files.forEach(element => {
        this.ImagenesForm.get('rutaImagen').setValue(element.name)
        this.ImagenesForm.get('idEmpresa').setValue(this.idEmpresa)
        this.servicioEmpresa.crearImagenes(this.ImagenesForm.value).subscribe(response => {
          this.guardarImagenPHP(imagen);
        })
      });
    }

    this.servicioEmpresa.actualizarEmpresa(this.idEmpresa, this.EmpresaForm.value).subscribe(response => {

      this.EmpresaForm.markAsPristine()
      this.EmpresaForm.markAllAsTouched()
      this.openSnackBar("INFORMACIÓN ACTUALIZADA!")
      this.router.navigateByUrl('/empresa')
    });
  }

    //GUARDAR IMAGEN EN PROYECTO
    guardarImagenPHP = (imagen: any) => {
      imagen._files.forEach(element => {
        this.ImagenesForm.controls['rutaImagen'].setValue(element);
        const imgData = new FormData();
        imgData.append('imagen', this.ImagenesForm.get('rutaImagen').value);
        this.serviciodocumento.guardarImg(imgData).subscribe(response => {
        });
      });
  
    }
  
    eliminarImagen = (id, name) =>{
      this.dialog.open(CuadroDialogoComponent).afterClosed().subscribe(confirm => {
        if (confirm) {
       this.servicioEmpresa.eliminarImagen(id).subscribe(response=>{
         this.serviciodocumento.eliminarImagen(name).subscribe(response =>{
  
         });
        this.openSnackBar("SE HA ELIMINADO CORRECTAMENTE")
        this.ngOnInit()
       })
        }
    
      })
    }

    radioSelected = (datos) =>{

      this.imagenes.forEach(element => {
        if(element.principal == 1){
          element.principal = 0;
          this.servicioEmpresa.actualizarEmpresaImagen(element.idImagen, element).subscribe(response =>{
          });
        }
      });
      datos.principal = 1;
      this.servicioEmpresa.actualizarEmpresaImagen(datos.idImagen, datos).subscribe(response =>{
        this.openSnackBar('El estado se ha actualizado!!')
        this.obtenerImagenes()
        this.labelPosition = 1
      });
    }

}
